import { diff3Merge } from "node-diff3";

const MAX_AUTOMERGE_CODE_POINTS = 200_000;
const CONFLICT_SUFFIX = "（冲突副本）";

export function mergeConcurrentText(base, local, remote) {
  if (local === remote) return { clean: true, text: local, reason: "identical" };
  if (local === base) return { clean: true, text: remote, reason: "remote-only" };
  if (remote === base) return { clean: true, text: local, reason: "local-only" };
  if (typeof base !== "string") return { clean: false, reason: "missing-base" };

  const totalLength = [...base].length + [...local].length + [...remote].length;
  if (totalLength > MAX_AUTOMERGE_CODE_POINTS) {
    return { clean: false, reason: "too-large" };
  }

  const blocks = diff3Merge([...local], [...base], [...remote], {
    excludeFalseConflicts: true,
  });
  if (blocks.some((block) => block.conflict)) {
    return { clean: false, reason: "overlapping-edits" };
  }
  return {
    clean: true,
    text: blocks.flatMap((block) => block.ok || []).join(""),
    reason: "non-overlapping-edits",
  };
}

export function conflictCopyBody(body) {
  const lines = body.split("\n");
  const firstMeaningfulIndex = lines.findIndex((line) => line.trim());
  if (firstMeaningfulIndex === -1) return `未命名笔记${CONFLICT_SUFFIX}`;
  const title = lines[firstMeaningfulIndex].replace(/(?:\s*（冲突副本）)+\s*$/, "").trimEnd();
  lines[firstMeaningfulIndex] = `${title} ${CONFLICT_SUFFIX}`;
  return lines.join("\n");
}

export async function conflictCopyId(noteId, leftOpId, rightOpId) {
  const operationIds = [leftOpId || "unknown", rightOpId || "unknown"].sort();
  const input = new TextEncoder().encode(
    `light-boat:conflict-copy:v1:${noteId}:${operationIds.join(":")}`,
  );
  const digest = new Uint8Array(await crypto.subtle.digest("SHA-256", input));
  const value = btoa(String.fromCharCode(...digest.subarray(0, 18)))
    .replaceAll("+", "-")
    .replaceAll("/", "_")
    .replace(/=+$/, "");
  return `conflict.${value}`;
}
